"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.seek = void 0;
const log_1 = require("./log");
const video_fragment_1 = require("./video/video-fragment");
const seek = ({ mediaRef, time, logLevel, why, }) => {
    // iOS seeking does not support multiple decimals
    const timeToSet = (0, video_fragment_1.isIosSafari)() ? Number(time.toFixed(1)) : time;
    log_1.Log.trace(logLevel, `[seek] from ${mediaRef.currentTime} to ${timeToSet}. Reason: ${why}`);
    mediaRef.currentTime = timeToSet;
    return timeToSet;
};
exports.seek = seek;
